import dataset from "@/data/anarchy-feed.json";
import { anarchyDatasetSchema } from "@/schemas/geodata";
import type {
  ActorGraph,
  AnarchyDataset,
  Leader,
  PressurePoint,
  Region,
  RegionEvent,
  ThemeConstellation,
} from "@/types/geodata";

export interface AnarchyRepository {
  getDataset(): AnarchyDataset;
  getRegions(): Region[];
  getRegion(regionId: string): Region | undefined;
  getPressurePoints(): PressurePoint[];
  getEvents(regionId?: string): RegionEvent[];
  getActorGraph(regionId: string): ActorGraph | undefined;
  getLeaders(): Leader[];
  getThemeConstellation(): ThemeConstellation;
}

class JsonAnarchyRepository implements AnarchyRepository {
  private readonly data = anarchyDatasetSchema.parse(dataset) as AnarchyDataset;

  getDataset() {
    return this.data;
  }

  getRegions() {
    return this.data.regions;
  }

  getRegion(regionId: string) {
    return this.data.regions.find((region) => region.id === regionId);
  }

  getPressurePoints() {
    return this.data.pressurePoints;
  }

  getEvents(regionId?: string) {
    if (!regionId) return this.data.events;
    return this.data.events.filter((event) => event.regionId === regionId);
  }

  getActorGraph(regionId: string) {
    return this.data.actorGraphs.find((graph) => graph.regionId === regionId);
  }

  getLeaders() {
    return this.data.leaders;
  }

  getThemeConstellation() {
    return this.data.themeConstellation;
  }
}

export const anarchyRepository: AnarchyRepository = new JsonAnarchyRepository();
